export function maskAccountNumber(value?: string | null): string {
  if (!value) return '';
  return value.length > 4 ? `*${value.slice(-4)}` : value;
}

export function capitalizeFirstLetter(str: string) {
  let _str = str.split('_').join(' ').toLowerCase();
  return _str.charAt(0).toUpperCase() + _str.slice(1);
}
export function underscoreToSpace(str: string) {
  return str.replace(/_/g, ' ');
}
